import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-323">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-324">
          {label}
          {props.required && <span className="text-red-500 ml-1" data-id="element-325">*</span>}
        </label>}
      <select className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors bg-white ${error ? 'border-red-500' : 'border-gray-300'} ${className}`} {...props} data-id="element-326">
        <option value="" data-id="element-327">Select...</option>
        {options.map(option => <option key={option.value} value={option.value} data-id="element-328">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-329">{error}</p>}
    </div>;
}